import { toast } from "react-toastify";
import {
  GET_ALL_CATEGORIES,
  GET_ALL_USERS,
  GET_ANALYTICS_DATA,
  GET_CONTACT_LISTS,
  GET_ITEM_LISTING,
  GET_ITEM_TOTAL,
  GET_LOGS_DATA,
  GET_NEWSLETTER_LISTS,
  GET_ORDER_LISTS,
  GET_PAYMENT_LISTS,
  GET_SINGLE_STAFF,
  GET_STAFF_LISTING,
  GET_TOTAL_CATEGORIES,
  GET_TOTAL_USERS,
  GET_ALL_BRAND,
  GET_TRACK_STATUS,
  GET_DISPUTE_DATA,
  GET_ORDER_DETAIL,
  GET_DISPUTE_DETAIL,
  GET_SIZES,
  GET_LEDGER,
  GET_BULK_DATA,
  GET_RETURN_DATA,
  RETURN_ORDER_DETAIL,
  GET_BULK_DETAIL,
  GET_BULK_ITEMS,
  GET_STRIKE_DATA,
  GET_RESTRICTION_DATA,
  GET_ORDER_AUDIT_LOGS,
} from "./userTypes";
import { start_loading, stop_loading } from "../loader/loaderAction";
import moment from "moment";
import { RESET_TOKEN, USER_DETAILS } from "../auth/authTypes";
import apiClient from "../../api/apiClient";
import { authStorage } from "../../api/authStorage";
import i18n from "../../i18n/i18n";

export const getDesignations = () => [
  { label: i18n.t("addEditStaff.reviewers"), value: "reviewers" },
  { label: i18n.t("addEditStaff.managers"), value: "managers" },
  { label: i18n.t("addEditStaff.owners"), value: "owners" },
];

export const show_success = (message) => {
  toast(message, { autoClose: 2000, });
};


// check token expired function 
export const check_token_expired_logout = (data, dispatch) => {
  if (data?.request?.status === 401) {
    toast.error(data.response.data.error, { toastId: "sessionexpired", autoClose: 2000 });
    dispatch({ type: RESET_TOKEN, payload: true });
    setTimeout(() => {
      localStorage.clear();
      authStorage.clear();
      window.location.reload();
    }, 2000);
  }
};

// upload images function 
export const upload_image = async (photo, dispatch) => {
  const formData = new FormData();
  formData.append("image", photo);
  try {
    const urlPath = `admin/upload-image`;
    const res = await apiClient.post(urlPath, formData);
    if (res.data && res.data.status) {
      return res;
    } else {
      toast.error(res.data.message, { toastId: "photoerr", autoClose: 2000 });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// update admin password 
export const update_password = async (userdata, dispatch) => {
  try {
    const urlPath = `admin/change-password`;
    const res = await apiClient.post(urlPath, userdata, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "updatpwd", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "updatedpwderr", autoClose: 1000, });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get users data 
export const get_users = async (dispatch, currentPage, perPage, search, status, role, approval_status, restrictionType) => {
  try {
    let urlPath = `admin/user-list?page=${currentPage}&limit=${perPage}`;
    if (search) urlPath += `&search=${search}`;
    if (status && status !== "All") urlPath += `&${role === "buyer" ? "buyer_status" : "seller_status"}=${status}`;
    if (role) urlPath += `&role=${role}`;
    if (restrictionType && restrictionType !== "All") urlPath += `&restriction_type=${restrictionType}`;
    const res = await apiClient.get(urlPath);
    if (res?.data?.data) {
      dispatch({ type: GET_ALL_USERS, payload: res?.data?.data });
      dispatch({ type: GET_TOTAL_USERS, payload: Number(res.data.length) });
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get user detail data 
export const get_particular_user = async (id, dispatch) => {
  try {
    const urlPath = `admin/user-details/${id}`;
    const res = await apiClient.get(urlPath);
    if (res?.data?.data) {
      return res?.data?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get newsletter listing 
export const get_newsletter_lists = async (dispatch, page, limit, search) => {
  try {
    let urlPath = `admin/get-newsletter?page=${page}&limit=${limit}`;
    if (search) urlPath += `&search=${search}`;
    const res = await apiClient.get(urlPath);
    if (res?.data && res?.data?.status) {
      dispatch({ type: GET_NEWSLETTER_LISTS, payload: res?.data });
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// delete newsletter
export const delete_newsletter_email = async (dispatch, id) => {
  try {
    const urlPath = `admin/delete-newsletter/${id}`;
    const res = await apiClient.delete(urlPath);
    if (res?.data && res?.data?.status) {
      toast.success(res.data.message, { toastId: "deletenewsletter", autoClose: 2000, });
      return true;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get query listing 
export const get_contact_lists = async (dispatch, page, limit, search, filters = {}) => {
  try {
    const queryParams = new URLSearchParams({ page, limit });
    if (search) queryParams.append("search", search);
    Object.entries(filters).forEach(([key, value]) => {
      if (value) queryParams.append(key, value);
    });
    const urlPath = `admin/get-query-form?${queryParams.toString()}`;
    const res = await apiClient.get(urlPath);
    if (res?.data && res?.data?.status) {
      dispatch({ type: GET_CONTACT_LISTS, payload: res?.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// update query detail
export const update_query_detail = async (dispatch, id, data) => {
  try {
    const urlPath = `admin/edit-query-form/${id}`;
    const payload = {
      ...data,
      priority: data?.priority || "LOW",
    };
    const res = await apiClient.put(urlPath, payload, {
      headers: { "Content-Type": "application/json" },
    });
    if (res?.data && res?.data?.status) {
      toast.success(res.data.message, {
        toastId: "updatequerydetail",
        autoClose: 2000,
      });
      return res;
    }
    toast.error(res?.data?.message || "Unable to update query", {
      toastId: "updatequerydetailerr",
      autoClose: 2000,
    });
    return false;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Unable to update query", {
      toastId: "updatequerydetailerr",
      autoClose: 2000,
    });
    check_token_expired_logout(error, dispatch);
    return false;
  }
};


// update user data 
export const update_user = async (id, data, navigate, dispatch, isActive, message) => {
  try {
    const urlPath = `admin/user-edit/${id}`;
    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json" }
    });
    if (res?.data?.data) {
      toast.success(res.data.message, { toastId: "updateuser", autoClose: 2000, });
      navigate("/users");
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// update admin profile 
export const update_admin = async (data, dispatch, options = {}) => {
  const { reload = true, showToast = true } = options;
  try {
    const urlPath = `admin/edit-profile`;
    const res = await apiClient.post(urlPath, JSON.stringify(data), {
      headers: { "Content-Type": "application/json" }
    });
    if (res.status && res?.data?.data) {
      // localStorage.setItem("profile", JSON.stringify(res?.data?.data));
      authStorage.saveProfile(res?.data?.data);
      dispatch({ type: USER_DETAILS, payload: res?.data?.data });
      if (showToast) {
        show_success("Profile Updated Successfully");
      }
      if (reload) {
        setTimeout(() => {
          window.location.reload();
        }, 2700);
      }
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get product listing 
export const get_all_sell_Item = async (dispatch, page, limit, listtype, queryCat) => {
  try {
    const urlPath = `admin/list-item?status=${listtype}&page=${page}&limit=${limit}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_ITEM_LISTING, payload: res.data.data });
      dispatch({ type: GET_ITEM_TOTAL, payload: res.data.length });
      return res;
    } else {
      dispatch({ type: GET_ITEM_LISTING, payload: [] });
      dispatch({ type: GET_ITEM_TOTAL, payload: 0 });
      return null;
    }
  } catch (error) {
    dispatch({ type: GET_ITEM_LISTING, payload: [] });
    dispatch({ type: GET_ITEM_TOTAL, payload: 0 });
    check_token_expired_logout(error, dispatch);
  }
};


// bulk product approved and reject 
export const bulk_approved = async (dispatch, payload) => {
  dispatch(start_loading());
  try {
    let urlPath = `admin/bulk-approve-reject-items`;
    const res = await apiClient.patch(urlPath, payload, {
      headers: { "content-type": "application/json", },
    });
    if (res.data) {
      toast.success(res.data.message, { toastId: "savedSearches1fff" });
      return res;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  } finally {
    dispatch(stop_loading());
  }
};

// Pause or resume a live product.
export const toggle_item_active = async (dispatch, payload) => {
  dispatch(start_loading());
  try {
    const res = await apiClient.post("admin/toggle-item-active", payload, {
      headers: { "content-type": "application/json" },
    });
    if (res?.data) {
      toast.success(res.data.message);
      return res;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    }
    check_token_expired_logout(error, dispatch);
    return null;
  } finally {
    dispatch(stop_loading());
  }
};


// get product detail 
export const auction_details = async (slug, dispatch) => {
  try {
    const url = `admin/item-details/${slug}`;
    const res = await apiClient.get(url);
    if (res?.data && res?.data?.status) {
      return res.data.data;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// single product approved 
export const approve_auction = async (itemdata, navigate, dispatch, status) => {
  try {
    const url = `admin/approve-item`;
    const res = await apiClient.post(url, itemdata, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res?.data && res?.data?.status) {
      // show_success(status === "APPROVED" ? "Approved Successfully" : "Rejected Successfully");
      toast.success(res?.data?.message);
      return res.data;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  } finally {
  }
};


// create category 
export const add_category = async (data, dispatch) => {
  try {
    const urlPath = `admin/create-category`;
    const response = await apiClient.post(urlPath, data);
    if (response?.status >= 200 && response?.status < 300) {
      toast.success(response?.data?.message || "Category created successfully!");
    }
    return response;
  } catch (error) {
    if (error?.response?.status === 422) {
      toast.error(error?.response?.data?.message || "Category already exists!");
      return error.response;
    }
    if (error?.response?.data?.message) {
      toast.error(error?.response?.data?.message);
    } else {
      console.log("Something went wrong. Please try again.");
    }
    check_token_expired_logout(error, dispatch);
    throw error;
  }
};


// edit category 
export const edit_category = async (data, id, dispatch) => {
  try {
    const urlPath = `admin/edit-category/${id}`;
    const response = await apiClient.put(urlPath, data, {
      headers: { "Content-Type": "application/json" }
    });
    if (!response?.data?.status) {
      throw new Error("Network response was not ok");
    } else {
      toast.success(response.data.message, {
        toastId: "editcategory",
        autoClose: 2000,
      });
    }
    return response;
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};


// get category listing 
export const get_category = async (dispatch, page, limit, search, status) => {
  try {
    let urlPath = `admin/list-category?page=${page}&limit=${limit}`;
    if (search) urlPath += `&search=${search}`;
    if (status && status !== "All") urlPath += `&status=${status}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_CATEGORIES, payload: res.data.data });
      dispatch({
        type: GET_TOTAL_CATEGORIES,
        payload: Number(res.data.length), // backend sends length
      });
      return res.data;
    } else {
      console.log("Error: Invalid response format");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// delete category 
export const delete_category = async (id, dispatch, message) => {
  try {
    const urlPath = `admin/delete-category/${id}`;
    const res = await apiClient.delete(urlPath);
    if (res.data && res.data.status) {
      toast.success(res.data.message, {
        toastId: "activeinactivecategori",
        autoClose: 2000,
      });
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};


export const upload_sell_item_logal_docs = async (legal_doc, dispatch) => {
  try {
    const formData = new FormData();
    legal_doc.forEach((doc) => {
      formData.append("legal_doc", doc);
    });
    formData.append("type", "item/legalDocs");
    const urlPath = `add-item/legaldocs`;
    const res = await apiClient.post(urlPath, formData);
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.data.message);
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// delete faq question 
export const delete_faq_question = async (faqId, dispatch) => {
  try {
    const url = `cms/delete-content/${faqId}`;
    const res = await apiClient.delete(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      toastId: "deltefaw",
      autoClose: 2000,
    });
    check_token_expired_logout(error, dispatch);
  }
};


// get all staf lisiting 
export const get_all_staff = async (dispatch, page, limit, search, uid) => {
  try {
    const urlPath = `admin/staff-list?page=${page}&limit=${limit}${search ? `&search=${search}` : ""
      }`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_STAFF_LISTING, payload: { ...res.data, uid: uid } });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};


// get single staff detail 
export const get_staff = async (dispatch, id) => {
  try {
    const urlPath = `admin/get-staff/${id}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_SINGLE_STAFF, payload: res.data.data });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};


// create staff 
export const manage_staff = async (data, id, dispatch) => {
  try {
    const urlPath = id ? `admin/staff-edit/${id}` : `admin/create-user`;
    const res = await (id ? apiClient.put(urlPath, data) : apiClient.post(urlPath, data));
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    } else {
      toast.error(res.data.error, {
        toastId: "errorsearchsaved",
        autoClose: 1000,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};


// get all orders listing 
export const get_all_orders = async (dispatch, page, limit) => {
  try {
    const urlPath = `admin/order-list?page=${page}&limit=${limit}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_ORDER_LISTS, payload: res.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get al payment data 
export const get_all_payments = async (dispatch, page, limit) => {
  try {
    const urlPath = `admin/payment-list?page=${page}&limit=${limit}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_PAYMENT_LISTS, payload: res.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get analytics data 
export const get_analytics_data = async (dispatch, timeRange = "7d") => {
  try {
    const query = timeRange ? `?period=${encodeURIComponent(timeRange)}` : "";
    const urlPath = `admin/dashboard_analytics${query}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_ANALYTICS_DATA, payload: res.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get audit logsc tracking data 
export const get_logs_data = async (dispatch, page, limit, queryString = "") => {
  try {
    // const urlPath = `admin/user-logs?page=${page}&limit=${limit}&action_type=${filterval}`;
    const urlPath = `admin/user-logs?page=${page}&limit=${limit}${queryString ? '&' + queryString : ''}`;
    // const res = await apiClient.get(urlPath);
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_LOGS_DATA, payload: res.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// create brand 
export const add_brand = async (data, dispatch) => {
  try {
    const urlPath = `admin/add-brand`;
    const res = await apiClient.post(urlPath, data);
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "addbrand", autoClose: 2000, });
      return true;
    } else {
      toast.success(res.data.error, { toastId: "addbranderror", autoClose: 2000, });
      return false;
    }
  } catch (error) {
    toast.error(error.response?.data?.error);
    return false;
  }
};


// get brand listing
export const get_brand = async (dispatch, page, limit, search, status) => {
  try {
    let urlPath = `admin/get-brands?page=${page}&limit=${limit}`;
    if (search) urlPath += `&search=${search}`;
    if (status && status !== "All") urlPath += `&is_active=${status}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_BRAND, payload: res.data });
      return res;
    } else {
      console.log("Error: Invalid response format");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// edit brand 
export const edit_brand = async (data, id, dispatch) => {
  try {
    const urlPath = `admin/edit-brand?id=${id}`;
    const response = await apiClient.put(urlPath, data, {
      headers: { "Content-Type": "application/json" }
    });
    if (!response?.data?.status) {
      throw new Error("Network response was not ok");
    } else {
      toast.success(response.data.message, { toastId: "editbrand", autoClose: 2000, });
      return response
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get trackment status
export const get_track_status = async (dispatch, parcel_id) => {
  try {
    let urlPath = `admin/track_shipment?parcelId=${parcel_id}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.message) {
      dispatch({ type: GET_TRACK_STATUS, payload: res.data });
      return res;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// edit order status 
export const change_order_status = async (payload) => {
  try {
    let urlPath = `admin/edit-order-admin`;

    const res = await apiClient.put(urlPath, payload, {
      headers: { "Content-Type": "application/json", },
    });

    if (res.data && res.data.message) {
      toast.success(res.data.message, { toastId: "succesone" });
      return res;
    }
  } catch (error) {
    check_token_expired_logout(error);
  }
};


// download invoices 
export const download_invoice = async (dispatch, id, type = 'buyer') => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/download-pdf?role=${type}`;
    const response = await apiClient.post(urlPath, { orderId: id }, {
      headers: { Accept: "application/pdf", },
      responseType: "blob",
    });
    return response;
  } catch (error) {
    console.error("API error:", error);
    throw error;
  } finally {
    dispatch(stop_loading());
  }
};

// download return invoices 
export const download_return_invoice = async (dispatch, payloud) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/download-return-invoice`;
    const response = await apiClient.post(
      urlPath,
      payloud,
      {
        headers: {
          Accept: "application/pdf",
        },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  } finally {
    dispatch(stop_loading());
  }
};


// get disputes listing 
export const get_dispute_lists = async (dispatch, page, limit) => {
  try {
    let urlPath = `admin/get-dispute-order?page=${page}&limit=${limit}`;
    const res = await apiClient.get(urlPath);
    if (res?.data && res?.data?.status) {
      dispatch({ type: GET_DISPUTE_DATA, payload: res?.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// get return listing 
export const get_return_data = async (dispatch, page, limit) => {
  try {
    let urlPath = `admin/return-items?page=${page}&limit=${limit}`;
    const res = await apiClient.get(urlPath);
    if (res?.data && res?.data?.status) {
      dispatch({ type: GET_RETURN_DATA, payload: res?.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// get return order detail 
export const get_return_order_detail = async (dispatch, id) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/return-item-detail?return_request_id=${id}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: RETURN_ORDER_DETAIL, payload: res.data.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  } finally {
    dispatch(stop_loading());
  }
};



// change dispute status 
export const change_dispute_status = async (payload) => {
  try {
    let urlPath = `admin/update-dispute-order`;
    const res = await apiClient.put(urlPath, payload, {
      headers: { "Content-Type": "application/json", },
    });
    if (res.data && res.data.message) {
      toast.success(res.data.message, { toastId: "succesone" });
      return res;
    }
  } catch (error) {
    check_token_expired_logout(error);
  }
};


// get dispute detail 
export const get_dispute_detail = async (dispatch, orderid, disputeid) => {
  try {
    let urlPath = `admin/get-dispute-order/?orderid=${orderid}&disputeid=${disputeid}`;
    const res = await apiClient.get(urlPath);
    if (res?.data && res?.data?.status) {
      dispatch({ type: GET_DISPUTE_DETAIL, payload: res?.data?.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get order detail 
export const get_order_detail = async (dispatch, id) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/order-detail-admin/?orderId=${id}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_ORDER_DETAIL, payload: res.data.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// download return labels 
export const download_return_label = async (dispatch, id) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/download-return-label/${id}`;
    const response = await apiClient.get(urlPath,
      { headers: { Accept: "application/pdf", }, responseType: "blob", }
    );
    return response;
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  } finally {
    dispatch(stop_loading());
  }
};

// get order audit logs
export const get_order_audit_logs = async (dispatch, id) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/order-timeline/${id}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_ORDER_AUDIT_LOGS, payload: res.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// user subscribe notification 
export const user_subscribe_notification = async (data, dispatch) => {
  try {
    const urlPath = `admin/subscribe-firebase-topics`;
    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      return true;
    }
  } catch (error) {
    if (error.status === 403) {
      toast.error("Token is Expired", { toastId: "sessionexpir", autoClose: 2000 });
      // dispatch({ type: RESET_TOKENS, payload: true });
      setTimeout(() => {
        localStorage.clear();
        authStorage.clear();
        window.location.reload();
      }, 2000);
    } else {
      check_token_expired_logout(error, dispatch);
    }
  }
};


// user approve or rejected
export const approved_user = async (id, data, navigate, dispatch) => {
  try {
    const urlPath = `admin/user-edit/${id}`;

    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json", },
    });
    console.log("Response from approved_user:", res);
    if (res?.data?.status) {
      toast.success(`Seller ${data?.seller_status == 'SELLER_REJECTED' && 'rejected' || data?.seller_status == 'SELLER_ACTIVE' && 'activated'} successfully`, {
        toastId: "approved",
        autoClose: 2000,
      });
      navigate("/users");
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// create sizes 
export const add_sizes = async (data, dispatch) => {
  try {
    const urlPath = `admin/add-sizes`;
    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json", },
    }
    );
    if (res?.data?.data && res?.data?.status) {
      toast.success(res?.data?.message, { toastId: "approved", autoClose: 2000 });
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get sizes 
export const get_sizes = async (dispatch, currentPage, perPage) => {
  try {
    const urlPath = `admin/get-sizes?page=${currentPage}&limit=${perPage}`;
    const res = await apiClient.get(urlPath);
    if (res?.data?.data) {
      dispatch({ type: GET_SIZES, payload: res.data });
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// edit sizes 
export const edit_sizes = async (id, data, dispatch) => {
  try {
    const urlPath = `admin/edit-size/${id}`;
    const res = await apiClient.put(urlPath, data, {
      headers: { "Content-Type": "application/json", },
    }
    );
    if (res?.data?.data) {
      toast.success(res?.data?.message, { toastId: "edit_sizes", autoClose: 2000 });
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// delete sizes 
export const delete_size = async (id, data, dispatch) => {
  try {
    const urlPath = `admin/delete-size/${id}`;
    const res = await apiClient.delete(urlPath, data, {
      headers: { "Content-Type": "application/json", },
    }
    );
    if (res?.data?.data) {
      toast.success(res?.data?.message, { toastId: "delete_size", autoClose: 2000 });
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// delete sub categories 
export const delete_sub_category = async (id, data, dispatch) => {
  try {
    const urlPath = `admin/delete-subcategory/${id}`;
    const res = await apiClient.delete(urlPath, data, {
      headers: { "Content-Type": "application/json", },
    }
    );
    if (res?.data?.data) {
      toast.success(res?.data?.message, { toastId: "approved", autoClose: 2000 });
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// edit sub categories 
export const edit_sub_category = async (id, data, dispatch) => {
  try {
    const urlPath = `admin/edit-subcategory/${id}`;

    const res = await apiClient.put(urlPath, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (res?.data?.data) {
      toast.success(res?.data?.message, {
        toastId: "edit_sub_category",
        autoClose: 2000,
      });

      return true;
    } else {
      toast.error(
        res?.data?.error || "Something went wrong",
        {
          toastId: "error_manage_sub_category",
          autoClose: 2000,
        }
      );
    }
  } catch (error) {

    if (error?.response?.status === 409) {
      toast.error(
        error?.response?.data?.error || "Subcategory already exists",
        {
          toastId: "subcategory_exists",
          autoClose: 2000,
        }
      );
    } else {
      toast.error(
        error?.response?.data?.error || "Something went wrong",
        {
          toastId: "general_error",
          autoClose: 2000,
        }
      );
    }

    check_token_expired_logout(error, dispatch);
  }
};


// create sub categories 
export const manage_sub_category = async (data, dispatch) => {
  try {
    const urlPath = "admin/create-subcategory";
    const response = await apiClient.post(urlPath, data);
    if (response?.status >= 200 && response?.status < 300) {
      toast.success(response?.data?.message, {
        toastId: "manage_sub_category",
        autoClose: 2000,
      });
      return true;
    }
    return response;
  } catch (error) {
    console.log("API ERROR:", error);
    if (error?.response?.status === 409) {
      toast.error(
        error?.response?.data?.error || "Subcategory already exists",
        {
          toastId: "error_manage_sub_category",
          autoClose: 2000,
        }
      );
    } else {
      toast.error("Something went wrong", {
        toastId: "general_error",
        autoClose: 2000,
      });
    }
    check_token_expired_logout(error, dispatch);
  }
};

export const refund_payment = async (dispatch, id) => {
  try {
    console.log("Refund API called with ID:", id);
    const urlPath = `admin/admin-refund-amount/${id}`;;
    const response = await apiClient.patch(urlPath);
    if (response?.status >= 200 && response?.status < 300) {
      toast.success(response?.data?.message, {
        toastId: "manage_sub_category",
        autoClose: 2000,
      });
      return true;
    }
    return response;
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
}

export const seller_payment_hold = async (dispatch, data) => {
  try {
    const urlPath = `admin/create-payout-hold`;
    const response = await apiClient.post(urlPath, data);
    if (response?.status >= 200 && response?.status < 300) {
      toast.success(response?.data?.message, {
        toastId: "manage_sub_category",
        autoClose: 2000,
      });
      return true;
    }
    return response;
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
}

export const seller_payment_release = async (dispatch, data) => {
  try {
    const urlPath = `admin/release-payout-hold`;
    const response = await apiClient.post(urlPath, data);
    if (response?.status >= 200 && response?.status < 300) {
      toast.success(response?.data?.message, {
        toastId: "manage_sub_category",
        autoClose: 2000,
      });
      return true;
    }
    return response;
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
}


export const get_ledger_data = async (dispatch, page = 1, limit = 10, filters = {}) => {
  dispatch(start_loading());
  try {
    let urlPath = `admin/seller-ledger?page=${page}&limit=${limit}`;
    if (filters?.search) urlPath += `&search=${filters?.search}`;
    if (filters?.event_type && filters?.event_type !== "all") urlPath += `&event_type=${filters?.event_type}`;
    if (filters?.payout_type && filters?.payout_type !== "all") urlPath += `&direction=${filters?.payout_type}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_LEDGER, payload: res?.data });
      return res;
    }
  } catch (error) {
  } finally {
    dispatch(stop_loading());
  }
}
// get bulk data
export const get_bulk_data = async (dispatch, page, limit, params = {}) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    Object.entries(params || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    });

    const urlPath = `admin/csv-upload-histroy?${queryParams.toString()}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.status) {
      dispatch({ type: GET_BULK_DATA, payload: res.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// get bulk data detail
export const get_bulk_data_detail = async (dispatch, params) => {
  try {
    const urlPath = `admin/csv-upload-histroy/${params.bulk_id}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.status) {
      dispatch({ type: GET_BULK_DETAIL, payload: res.data.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// get bulk data items
export const get_bulk_items = async (dispatch, params) => {
  try {
    const queryParams = new URLSearchParams({
      page: params.page || 1,
      limit: params.limit || 10,
      bulk_id: params.bulk_id,
      status: params.selectedTab,
    });
    const urlPath = `admin/list-item?${queryParams.toString()}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.status) {
      dispatch({ type: GET_BULK_ITEMS, payload: res.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// get strike categories data according selected category 
export const get_Strike_Category_item = async (dispatch, category, userId, search) => {
  try {
    const queryParams = new URLSearchParams({ page: 1, limit: 5 });
    if (userId) queryParams.append("user_id", userId);
    if (search) queryParams.append("search", search);

    let urlPath;
    if (category == "SELLER_MISLEADING_PRODUCT" || category == "SELLER_STOCK_MISMATCH") urlPath = `admin/list-item?${queryParams.toString()}`;
    else if (category == "SELLER_LATE_SHIPMENT" || category == "SELLER_DOES_NOT_SHIP") urlPath = `admin/order-list?${queryParams.toString()}`;
    else if (category == "SELLER_NO_RESPONSE") urlPath = `admin/get-dispute-order?${queryParams.toString()}`;
    else if (category == "BUYER_RETURN_ABUSE") urlPath = `admin/return-items?${queryParams.toString()}`;
    else if (category == "BUYER_UNPAID_FINAL_SALE" || category == "BUYER_BID_MANIPULATION") urlPath = `admin/bid-list?${queryParams.toString()}`;
    else return [];

    const res = await apiClient.get(urlPath);
    if (res.data && res.status) {
      return res.data.data;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// apply strike function
export const apply_strike = async (dispatch, data) => {
  try {
    const urlPath = `admin/strike/apply`;
    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "apply_strike", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "apply_strikeerr", autoClose: 1000, });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// get strike data based on account id
export const get_strike_data = async (dispatch, userId) => {
  try {
    const urlPath = `admin/strike/account/${userId}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_STRIKE_DATA, payload: res.data.data.strikes });
      return res.data.data;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// close strike 
export const close_strike = async (dispatch, id, data) => {
  if (!id) {
    toast.error("Unable to close strike", { toastId: "close_strikeerr", autoClose: 1000 });
    return false;
  }

  try {
    const urlPath = `admin/strike/close/${id}`;
    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "close_strike", autoClose: 1000 });
      return true;
    } else {
      toast.error(res?.data?.message || "Unable to close strike", { toastId: "close_strikeerr", autoClose: 1000 });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
    toast.error(error?.response?.data?.message || "Unable to close strike", { toastId: "close_strikeerr", autoClose: 1000 });
    return false;
  }
}


// apply restriction on user function
export const apply_restriction = async (dispatch, data) => {
  try {
    const urlPath = `admin/restriction/apply`;
    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "restriction", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "restrictionerr", autoClose: 1000, });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// close restriction on user function
export const close_restriction = async (dispatch, id, data = {}) => change_restriction_status(dispatch, "close", id, data);


// restore restriction on user function
export const restore_restriction = async (dispatch, id, data = {}) => change_restriction_status(dispatch, "restore", id, data);

export const change_restriction_status = async (dispatch, type, id, data = {}) => {
  if (!id) {
    toast.error("Unable to update restriction", { toastId: "restriction_status_error", autoClose: 1000 });
    return false;
  }
  const normalizedType = String(type || "").toLowerCase();
  const actionPath = normalizedType === "restore" ? "restore" : "remove";
  const actionLabel = normalizedType === "restore" ? "restore" : "close";
  try {
    const urlPath = `admin/restriction/${actionPath}`;
    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: `${actionLabel}_restriction`, autoClose: 1000 });
      return true;
    } else {
      toast.error(res?.data?.message || `Unable to ${actionLabel} restriction`, { toastId: `${actionLabel}_restrictionerror`, autoClose: 1000 });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
    toast.error(error?.response?.data?.message || `Unable to ${actionLabel} restriction`, { toastId: `${actionLabel}_restrictionerror`, autoClose: 1000 });
    return false;
  }
};

// get restriction data based on account id
export const get_restriction_data = async (dispatch, userId) => {
  try {
    const urlPath = `admin/restriction/account/${userId}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      dispatch({ type: GET_RESTRICTION_DATA, payload: res.data.data });
      return res.data.data;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// admin decision when buyer not shipment on time function
export const return_admin_decision = async (dispatch, payload) => {
  try {
    const { id, action, ...data } = payload;
    const urlPath = `admin/return-requests/${id}/${action}`;
    const res = await apiClient.patch(urlPath, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "returnadmindecision", autoClose: 3000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "returnadmindecisionerr", autoClose: 3000, });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// admin decision when buyer not shipment on time function
export const return_mark_as_received = async (dispatch, id, type) => {
  try {
    let urlPath;
    if (type === 'bid4style') {
      urlPath = `admin/return-requests/${id}/mark-received`;
    } else {
      urlPath = `admin/return-requests/${id}/mark-external`;
    }
    const res = await apiClient.patch(urlPath, {}, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "returnadmindecision", autoClose: 3000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "returnadmindecisionerr", autoClose: 3000, });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};


// cancel order function
export const cancel_order = async (dispatch, data) => {
  try {
    const urlPath = `admin/cancel-order-exception`;
    const res = await apiClient.post(urlPath, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "cancel_order", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "cancel_ordererr", autoClose: 1000, });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// extend seller shipment deadline for an order under admin review
export const extend_shipment_deadline = async (dispatch, id, data) => {
  try {
    const urlPath = `admin/order/${id}/extend-shipment-deadline`;
    const res = await apiClient.patch(urlPath, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "extend_shipment_deadline", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "extend_shipment_deadline_err", autoClose: 1000 });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// get shipping methods for admin-created shipment
export const get_shipping_methods = async (dispatch, postalCode, order_id, packageDetails = {}) => {
  try {
    const { weight_kg, length_cm, width_cm, height_cm } = packageDetails;
    let urlPath = `admin/shipment_methods?from_postal_code=${postalCode}&is_return=false&order_id=${order_id}`;
    if (weight_kg) urlPath += `&weight_kg=${weight_kg}`;
    if (length_cm) urlPath += `&length_cm=${length_cm}`;
    if (width_cm) urlPath += `&width_cm=${width_cm}`;
    if (height_cm) urlPath += `&height_cm=${height_cm}`;
    const res = await apiClient.get(urlPath);
    return res?.data?.data || [];
  } catch (error) {
    check_token_expired_logout(error, dispatch);
    return [];
  }
};

// admin creates the shipment/parcel on the seller's behalf
export const admin_create_shipment = async (dispatch, payload) => {
  try {
    const urlPath = `admin/order/admin-create-shipment`;
    const res = await apiClient.post(urlPath, payload, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "admin_create_shipment", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "admin_create_shipment_err", autoClose: 1000 });
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

